// DragScroll.js
import React, { useRef, useEffect } from "react";

const DragScroll = ({
  children,
  className = "",
  style = {},
  dragSpeed = 1,
}) => {
  const containerRef = useRef(null);
  const isDownRef = useRef(false);
  const startXRef = useRef(0);
  const scrollLeftRef = useRef(0);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    // mouse handlers
    const onMouseDown = (e) => {
      e.stopPropagation();
      isDownRef.current = true;
      el.classList.add("dragging");
      startXRef.current = e.pageX - el.offsetLeft;
      scrollLeftRef.current = el.scrollLeft;
      // prevent image drag ghost interfering (extra safety)
      e.preventDefault();
    };
    const onMouseLeave = () => {
      isDownRef.current = false;
      el.classList.remove("dragging");
    };
    const onMouseUp = () => {
      isDownRef.current = false;
      el.classList.remove("dragging");
    };
    const onMouseMove = (e) => {
      if (!isDownRef.current) return;
      e.preventDefault();
      e.stopPropagation();
      const x = e.pageX - el.offsetLeft;
      const walk = (x - startXRef.current) * dragSpeed;
      el.scrollLeft = scrollLeftRef.current - walk;
    };

    // touch handlers for mobile
    const onTouchStart = (e) => {
      e.stopPropagation();
      isDownRef.current = true;
      startXRef.current = e.touches[0].pageX - el.offsetLeft;
      scrollLeftRef.current = el.scrollLeft;
    };
    const onTouchEnd = () => {
      isDownRef.current = false;
    };
    const onTouchMove = (e) => {
      if (!isDownRef.current) return;
      e.stopPropagation();
      const x = e.touches[0].pageX - el.offsetLeft;
      const walk = (x - startXRef.current) * dragSpeed;
      el.scrollLeft = scrollLeftRef.current - walk;
    };

    // attach
    el.addEventListener("mousedown", onMouseDown);
    el.addEventListener("mouseleave", onMouseLeave);
    window.addEventListener("mouseup", onMouseUp);
    window.addEventListener("mousemove", onMouseMove);

    el.addEventListener("touchstart", onTouchStart, { passive: true });
    el.addEventListener("touchend", onTouchEnd);
    el.addEventListener("touchmove", onTouchMove, { passive: false });

    return () => {
      el.removeEventListener("mousedown", onMouseDown);
      el.removeEventListener("mouseleave", onMouseLeave);
      window.removeEventListener("mouseup", onMouseUp);
      window.removeEventListener("mousemove", onMouseMove);

      el.removeEventListener("touchstart", onTouchStart);
      el.removeEventListener("touchend", onTouchEnd);
      el.removeEventListener("touchmove", onTouchMove);
    };
  }, [dragSpeed]);

  return (
    <div
      ref={containerRef}
      className={className}
      style={{
        overflowX: "auto",
        cursor: "grab",
        WebkitOverflowScrolling: "touch",
        ...style,
      }}
    >
      {children}
    </div>
  );
};

export default DragScroll;
